module.exports = __webpack_public_path__ + "media/images/chart-36f5029ad1283cee0169ef2401f562a8.jpg";